import { useEffect, useState } from "react";
import style from "../AddReview.module.scss";
import RatingStarFilled from "@Icons/RatingStarFilled";
import RatingStarOutline from "@Icons/RatingStarOutline";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";

const StarButton = ({ filled, onClick, onMouseEnter, onMouseLeave, starSize }: any) => (
  <button
    type="button"
    onClick={onClick}
    className={style.starButton}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    {filled ? <RatingStarFilled size={starSize} /> : <RatingStarOutline size={starSize} />}
  </button>
);

const StarRatingDisplay = ({ currentStar }: any) => {
  let feedback = "";
  const { t } = useTranslationHook();
  if (currentStar + 1 === 1) {
    feedback = t("propertypage.reviewssection.addreview.addreviewform.poor");
  } else if (currentStar + 1 === 2) {
    feedback = t("propertypage.reviewssection.addreview.addreviewform.average");
  } else if (currentStar + 1 === 3) {
    feedback = t("propertypage.reviewssection.addreview.addreviewform.good");
  } else if (currentStar + 1 === 4) {
    feedback = t("propertypage.reviewssection.addreview.addreviewform.verygood");
  } else if (currentStar + 1 === 5) {
    feedback = t("propertypage.reviewssection.addreview.addreviewform.excellent");
  }
  return <p>{feedback}</p>;
};

const StarRating = ({
  defaultRating = 0,
  totalStars = 5,
  onChange = null,
  setShowError = null,
  starSize = 32,
  showDisplay = true,
}: any) => {
  const [currentStar, setCurrentStar] = useState(defaultRating - 1);
  const [hover, setHover]: any = useState(null);

  useEffect(() => {
    setCurrentStar(defaultRating - 1);
  }, [defaultRating]);

  const handleClick = (idx: any) => {
    if (setShowError) setShowError(false);
    if (idx === currentStar) {
      setCurrentStar(defaultRating - 1);
      onChange(defaultRating);
      setHover(null);
    } else {
      onChange(idx + 1);
      setCurrentStar(idx);
    }
  };

  return (
    <div className={style.starRatingContainer}>
      <div className={style.starRatingContainerInner}>
        {[...Array(totalStars)].map((_star, idx) => {
          const starRating = hover !== null ? hover : currentStar;
          const filled = (currentStar !== null || hover !== null) && idx <= starRating;

          return (
            <StarButton
              filled={filled}
              key={idx + 1}
              onClick={() => handleClick(idx)}
              starSize={starSize}
            />
          );
        })}
      </div>
      {showDisplay && <StarRatingDisplay currentStar={currentStar} />}
    </div>
  );
};
export default wrapperHOC(StarRating, {
  componentName: "StarRating-ReviewsSection",
  showForChina: true,
});
